<div class="form-inline">
  <div class="form-group">
    <input class="form-control " value="{{name}}"/>
    <button class="btn btn-primary btn-sm" data-action="save">save</button>
    <button class="btn btn-default btn-sm" data-action="cancel">cancel</button>
  </div>
</div>
